module.exports = __webpack_public_path__ + "graphics/checkout-secure-icon.ckh.53faf25e8b723d2e86ca71e428619af8.svg";